import * as modalTypes from "./modalTypes";
import * as fieldTypes from "./fieldTypes";
import * as filterTypes from "./filterTypes";
import * as specialtyCodes from "./specialtyCodes";
import * as tableColumnTypes from "./tableColumnTypes";
export * from "./practiceTeam";
import { translate } from "@td/shared_utils";

export const PAGE_SIZES = [50, 75, 100];
export const PAGE_SIZE_OPTIONS = PAGE_SIZES.map(value => ({ value, label: value}));
export const DEFAULT_PAGE_SIZE = PAGE_SIZES[0];

export const SPECIALTY_CD = {
  VPC: "VPC",
};
export * from "./tableColumns";
export * from "./filters";
export * from "./filterOptions";
export const SERVER_ERROR_MESSAGE = translate(null, "provider_panel", "server_error")

export const defaultPageParams = {
  page: 1,
  perPage: DEFAULT_PAGE_SIZE,
};

export const defaultFilters = {
  [filterTypes.PRACTICES]: [],
  [filterTypes.PROVIDERS]: [],
  [filterTypes.PROVIDER_LICENSES]: [],
  [filterTypes.STATUSES]: [],
  [filterTypes.PAYMENT_METHODS]: [],
  [filterTypes.ACCEPT_NEW_PATIENTS_STATUS]: [],
};

export const unassignedOption = {
  value: -1,
  label: translate(null, "provider_panel.filters.fields.practice", "unassigned"),
};

export const NOTIFICATION_COLORS = {
  70: "#0078BC",
  80: "#0078BC",
  90: "#E5AE00",
  100: "#CD000A",
};

export {
  filterTypes,
  modalTypes,
  fieldTypes,
  tableColumnTypes,
  specialtyCodes,
};
export { CREATE_FORM_FIELDS, FIELD_TYPES_BY_SPECIALTY, UPDATE_FORM_FIELDS, FORM_FIELDS_BY_SPECIALTY } from "./fields";

export { ACCEPTING_NEW_PATIENT_REASON } from  "./accepting_new_patients_reason_cd";
